import { lazy } from 'react';

export const RecoveryCodeFormAsync = lazy(() =>
  import('./RecoveryCodeForm').then((m) => ({ default: m.RecoveryCodeForm })),
);
